import { render } from "./page-homeowner.vue?vue&type=template&id=35d23f9a"
import script from "./page-homeowner.js?vue&type=script&lang=js"
export * from "./page-homeowner.js?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__